import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
interface CtaButtonProps {
  label: string;
  position: string;
  className?: string;
}
export function CtaButton({
  label,
  position,
  className = ''
}: CtaButtonProps) {
  const gclid = useGclid();
  const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
  const href = buildShopUrl(SHOP_URL, gclid);
  return <a href={href} onClick={() => trackCTAClick(label, position)} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center gap-3 bg-forestGreen text-white font-serif font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group w-full md:w-auto text-center ${className}`} data-id="element-14">
      {label}
      <ArrowRight className="group-hover:translate-x-1 transition-transform" data-id="element-15" />
    </a>;
}